"use strict";

exports.__esModule = true;
exports.PlantTwinScreen = PlantTwinScreen;
var _react = _interopRequireDefault(require("react"));
var _Screen = require("../../Core/Screen");
var _Translator = require("../../Core/Translator");
var _AppNavbar = require("../../App/AppNavbar");
var _PlantTwinScreenWrapper = require("../PlantTwinScreenWrapper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function PlantTwinScreen() {
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  return /*#__PURE__*/_react["default"].createElement(_Screen.Screen, {
    title: translate("PlantTwinScreen.title", "Plant Twin")
  }, /*#__PURE__*/_react["default"].createElement(_AppNavbar.AppNavbar, {
    title: translate("PlantTwinScreen.navbar.title", "Plant Twin")
  }), /*#__PURE__*/_react["default"].createElement(_PlantTwinScreenWrapper.PlantTwinScreenWrapper, null));
}